/** Shown when a check was never opened on this phone and there's no signal. */
export const NOT_ON_PHONE = 'No signal, and this check isn’t on this phone yet. Open it once where there’s signal — after that it works offline.';
